import React from "react";

function RadarSensorWideWidget() {
  return (
    <div className={`widget wide`}>
      <div className="widget-left">
        <div className="dashboard-widget-title">
          <h1 className="dashboard-widget-title-name">레이더 센서</h1>
          <p className="dashboard-widget-title-place">장소</p>
        </div>
        <div className="dashboard-widget-footer sensor">
          <p>지금 감지됨</p>
          <img
            src={`https://hejhome-square.s3.ap-northeast-2.amazonaws.com/1.0/button-icons/mo_sensor.png`}
            alt="sensor"
          />
        </div>
      </div>
      <div className="widget-right sensor">
        <h3>마지막 감지</h3>
        <div className="recent-detected">
          <small>2022년 0월 00일</small>
          <span>오전 09:41</span>
        </div>
      </div>
    </div>
  );
}

export default RadarSensorWideWidget;
